/**
 * Which way to turn the body when a region is chosen.
 *
 * The moment the map stops being a diagram and becomes a thing: pick "left
 * sleeve · back" and the avatar rotates to show you its left sleeve, from
 * behind. `frame()` already exists on the viewer; this is the missing half — a
 * region id to a camera preset.
 *
 * Pure, and its own module, because the mapping has one genuinely wrong answer
 * available (see `down`) and a wrong camera makes the feature look broken
 * rather than absent.
 */

import type { RegionId } from "../../shared/format";
import type { CameraPreset } from "../viewer/types";

export function presetForRegion(id: RegionId): CameraPreset {
  const face = id.split(".")[1] ?? "";
  switch (face) {
    case "front":
      return "front";
    case "back":
      return "back";
    case "left":
      return "left";
    case "right":
      return "right";
    case "up":
      return "top";
    /*
     * There is no "bottom" preset, and adding one would point the camera up
     * through the floor at a face the avatar's own body hides. Three-quarter is
     * the closest honest answer: the face is not really viewable, so the camera
     * backs off to a view where you can at least see where it is.
     */
    case "down":
      return "threeQuarter";
    default:
      return "threeQuarter";
  }
}
